import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  storeReservationItems: {
    associatesReservation: [],
    count: null,
  },
  foundReservations: {
    count: null,
    associatesReservation: [],
  },
  storeReservationFilters: {},
};

export const reservationsManagerHistory = (state = INITIAL_STATE, { type, payload }) => {
  const { resetPagination, associatesReservation = [], count } = payload || {};
  switch (type) {
    case actionTypes.RESERVATIONS_ITEMS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.RESERVATIONS_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        storeReservationItems: {
          associatesReservation: resetPagination
            ? associatesReservation
            : [...state.storeReservationItems.associatesReservation, ...associatesReservation],
          count,
        },
      };
    case actionTypes.RESERVATIONS_ITEMS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.RESERVATIONS_STORE_CLEAR:
      return {
        ...state,
        storeReservationItems: { ...INITIAL_STATE.storeReservationItems },
      };
    case actionTypes.SELECT_ASSOCIATE_RESERVATIONS:
      return {
        ...state,
        reservations: payload,
      };
    case actionTypes.RESERVATIONS_STORE_FILTERS:
      return {
        ...state,
        storeReservationFilters: {
          ...state.storeReservationFilters,
          ...payload,
        },
      };
    case actionTypes.RESERVATIONS_STORE_RESET_FILTERS:
      return {
        ...state,
        storeReservationFilters: INITIAL_STATE.storeReservationFilters,
      };
    default:
      return state;
  }
};

export default reservationsManagerHistory;
